.infoText {
  color: var(--body-text-arrows-400);
}

#local-sandbox-instance-form-field {
  margin-left: calc(var(--spacer) * 3.3);
}

.form-field-info-text-connection-settings {
  padding-top: calc(var(--spacer) * 0.5);
}

.helper-text {
  padding-top: calc(var(--spacer) * 0.5);
}

.section {
  margin-top: calc(var(--spacer) * 3);
  margin-bottom: -20px;
}

gz-radio {
  margin-right: calc(2 * var(--spacer));
}

gz-dropdown {
  --form-field-input-width: 400px;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(var(--spacer));
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-info-box {
  padding-left: calc(var(--spacer) * -1);
}
